import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { p, selectObjects } from "~/misc/common";

export default class extends Controller {
  connect() {
    console.log('initTeachingGroupsForm');
    const tps = $('#toJs').data('tps');
    const current_tp_id = $('#toJs').data('currenttpid');

    $("#teaching_group_parish_id").on('change', refresh);
    refresh();
    $('#teaching_group_teaching_place_id').val(current_tp_id);

    function refresh() {
      const tpssel = selectObjects(tps, 'parish_id', $('#teaching_group_parish_id').myGetNumValue());
      p(tpssel);
      const select = $('#teaching_group_teaching_place_id');
      select.empty();
      select.append($("<option value>plébániai</option>"));
      $(tpssel).each(function (k, o: any) {
        select.append($("<option></option>").attr("value", o.id).html(o.name_w_om));
      });
    }

    $('#teaching_times').on('cocoon:after-insert', function (e, image) {
      $(image).css('display', 'block');
      $(image).fadeIn('slow', function () {
        attachListeners($(image));
      });
    }).on('cocoon:before-remove', function (e, image) {
      $(this).data('remove-timeout', 1000);
      image.hide('slow');
    });

    $('.nested-fields').each(function () {
      attachListeners($(this));
    });

    function attachListeners(element: JQuery) {
      element.find('.clockpicker').clockpicker();
      element.find('.startClock').on('change', function () {
        const start_input = $(this).closest('.nested-fields').find('.teaching_group_teaching_times_start_s>input');
        const was = start_input.val() as any;
        start_input.val(getSeconds($(this)));
        const end_input = $(this).closest('.nested-fields').find('.teaching_group_teaching_times_end_s>input');
        const diff = (end_input.val() as any) - was;
        const end_val = Math.min(getSeconds($(this)) + diff, 86340);
        end_input.val(end_val);
        $(this).closest('.nested-fields').find('.endClock').val(getClock(end_val));
      });

      element.find('.endClock').on('change', function () {
        $(this).closest('.nested-fields').find('.teaching_group_teaching_times_end_s>input').val(getSeconds($(this)));
      });

      element.find('.duration-Xm').on('click', function () {
        const start_input = $(this).closest('.nested-fields').find('.teaching_group_teaching_times_start_s>input');
        const end_val = Math.min(parseInt(start_input.val() as any) + (parseInt($(this).text()) * 60), 86340);
        $(this).closest('.nested-fields').find('.teaching_group_teaching_times_end_s>input').val(end_val);
        $(this).closest('.nested-fields').find('.endClock').val(getClock(end_val));
      });
    }

    function getSeconds(input: JQuery) {
      const input_str = input.val() as string;
      const arr = input_str.split(':');
      let h = (arr.length > 0 && !isNaN(parseInt(arr[0]))) ? parseInt(arr[0]) : 8;
      let m = (arr.length > 1 && !isNaN(parseInt(arr[1]))) ? parseInt(arr[1]) : 0;
      h = h % 24;
      m = m % 60;
      const sec = h * 60 * 60 + m * 60;
      input.val(getClock(sec));
      return sec;
    }

    function getClock(sec: number) {
      return ('0' + Math.floor(sec / 3600)).slice(-2) + ':' + ('0' + (Math.floor(sec / 60) % 60)).slice(-2);
    }
  }
}